import { makeStyles } from '@material-ui/core/styles'

export const ReorderableNewsSectionStyles = makeStyles(() => ({
  dndDiv: {
    display: 'flex',
    flexDirection: 'row',
    height: '100%',
  },
}))
